import { twMerge } from 'tailwind-merge';
import clsx from 'clsx';

type DividerProps = {
  className?: string;
};

export default function Divider({ className }: DividerProps) {
  return (
    <div
      className={twMerge(clsx('border-b border-neutral-50 w-full', className))}
    />
  );
}
